'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Images = {
  account: {
    // Chưa import hết vào
    accountIcon: require('assets/img/account/accountIcon@3x.png'),
    address: require('assets/img/account/address@3x.png'),
    addressActive: require('assets/img/account/addressActive@3x.png'),
    app: require('assets/img/account/app@2x.png'),
    arrowForward: require('assets/img/account/arrowForward@2x.png'),
    booking: require('assets/img/account/booking.png'),
    defaultFreelance: require('assets/img/account/defaultFreelance.png'),
    newStarIcon: require('assets/img/account/newStar@3x.png'),
    yellowStarIcon: require('assets/img/account/yellowStar@3x.png')
  },
  payment: {
    plus_black: require('assets/img/payment/plus_black@3x.png'),
    lookme_wallet_background: require('assets/img/payment/lookme_wallet_background@2x.png'),
    historyIcon: require('assets/img/payment/historyIcon@3x.png'),
    moneyIcon: require('assets/img/payment/moneyIcon@3x.png'),
    atm: require('assets/img/payment/atm@2x.png'),
    mastercard: require('assets/img/payment/mastercard@2x.png'),
    momo: require('assets/img/payment/momo@2x.png'),
    visa: require('assets/img/payment/visa@2x.png'),
    checked: require('assets/img/payment/Checked@2x.png'),
    unChecked: require('assets/img/payment/unChecked@2x.png'),
    addMethod: require('assets/img/payment/addMethod@2x.png'),
    defaultCard: require('assets/img/payment/defaultCard@3x.png'),
    visaCard: require('assets/img/payment/visaCard@3x.png'),
    masterCard: require('assets/img/payment/masterCard@3x.png'),
    momoCard: require('assets/img/payment/momoCard@3x.png'),
    infoCirlce: require('assets/img/payment/infoCircle@3x.png'),
    cardConfirm: require('assets/img/payment/cardConfirm@3x.png'),
    map: require('assets/img/payment/map@2x.png'),
    hiddenNumber: require('assets/img/payment/hiddenNumber@2x.png'),
    visaTitle: require('assets/img/payment/visaTitle@2x.png'),
    lookmeWallet: require('assets/img/payment/lookmeWallet@3x.png')
  },
  cats: {
    spa: require('assets/img/cats/icon-spa@2x.png'),
    tatoo: require('assets/img/cats/icon-tatoo@2x.png'),
    fitness: require('assets/img/cats/icon-fitness@2x.png'),
    hair: require('assets/img/cats/icon-hair@2x.png'),
    cosmetic: require('assets/img/cats/icon-cosmetic@2x.png'),
    clinic: require('assets/img/cats/icon-clinic@2x.png'),
    homeService: require('assets/img/cats/icon-homeService@2x.png'),
    salonMiMong: require('../assets/img/cats/icon-salon-mi-va-mong@2x.png'),
    spaChamDa: require('../assets/img/cats/spa-cham-da@2x.png'),
    massageGoiDau: require('../assets/img/cats/massage-goi-dau@2x.png'),
    thamMyNhaKhoa: require('../assets/img/cats/tham-my-nha-khoa@2x.png'),
    salonTocMakeUp: require('../assets/img/cats/salon-toc-make-up@2x.png'),
    hoiThao: require('../assets/img/cats/hoi-thao@2x.png'),
    khoaHoc: require('../assets/img/cats/khoa-hoc@2x.png'),
    // inactive
    spaInactive: require('assets/img/cats/inactive-icon-spa@2x.png'),
    tatooInactive: require('assets/img/cats/inactive-icon-tatoo@2x.png'),
    fitnessInactive: require('assets/img/cats/inactive-icon-fitness@2x.png'),
    hairInactive: require('assets/img/cats/inactive-icon-hair@2x.png'),
    cosmeticInactive: require('assets/img/cats/inactive-icon-cosmetic@2x.png'),
    clinicInactive: require('assets/img/cats/inactive-icon-clinic@2x.png'),
    homeServiceInactive: require('assets/img/cats/inactive-icon-homeService@2x.png'),

    salonMiMongInactive: require('../assets/img/cats/icon-salon-mi-va-mong-inactive@2x.png'),
    spaChamDaInactive: require('../assets/img/cats/spa-cham-da-inactive@2x.png'),
    massageGoiDauInactive: require('../assets/img/cats/massage-goi-dau-inactive@2x.png'),
    thamMyNhaKhoaInactive: require('../assets/img/cats/tham-my-nha-khoa-inactive@2x.png'),
    salonTocMakeUpInactive: require('../assets/img/cats/salon-toc-make-up-inactive@2x.png'),
    hoiThaoInactive: require('../assets/img/cats/hoi-thao-inactive@2x.png'),
    khoaHocInactive: require('../assets/img/cats/khoa-hoc-inactive@2x.png'),

    // @webp
    spaWebp: require('assets/img/cats/icon-spa@2x.webp'),
    tatooWebp: require('assets/img/cats/icon-tatoo@2x.webp'),
    fitnessWebp: require('assets/img/cats/icon-fitness@2x.webp'),
    hairWebp: require('assets/img/cats/icon-hair@2x.webp'),
    cosmeticWebp: require('assets/img/cats/icon-cosmetic@2x.webp'),
    clinicWebp: require('assets/img/cats/icon-clinic@2x.webp'),
    homeServiceWebp: require('assets/img/cats/icon-homeService@2x.webp'),
    salonMiMongWebp: require('../assets/img/cats/icon-salon-mi-va-mong@2x.webp'),
    spaChamDaWebp: require('../assets/img/cats/spa-cham-da@2x.webp'),
    massageGoiDauWebp: require('../assets/img/cats/massage-goi-dau@2x.webp'),
    thamMyNhaKhoaWebp: require('../assets/img/cats/tham-my-nha-khoa@2x.webp'),
    salonTocMakeUpWebp: require('../assets/img/cats/salon-toc-make-up@2x.webp')
  },
  location: {
    locationDesktop: require('assets/img/location/locationDesktop.png'),
    locationMobile: require('assets/img/location/locationMobile@3x.png'),
    // @webp
    locationDesktopWebp: require('assets/img/location/locationDesktop.webp'),
    locationMobileWebp: require('assets/img/location/locationMobile.webp')
  },
  banner: {
    homeSlide1: require('assets/img/home/home-slide-1.jpg'),
    homeSlide2: require('assets/img/home/home-slide-2.jpg'),
    homeSlide3: require('assets/img/home/home-slide-3.jpg'),
    desktopBanner: require('assets/img/home/desktopBanner.jpg'),
    mobileBanner: require('assets/img/home/mobileBanner.jpg'),
    // @webp
    homeSlide1Webp: require('assets/img/home/home-slide-1.webp'),
    homeSlide2Webp: require('assets/img/home/home-slide-2.webp'),
    homeSlide3Webp: require('assets/img/home/home-slide-3.webp')
  },
  home: {
    imageLocationMobile: require('assets/img/location/locationMobile@3x.png'),
    activeDot: require('assets/img/home/activeDot.png'),
    inactiveDot: require('assets/img/home/inactiveDot.png'),
    closeBlack: require('assets/img/common/close_black.png'),
    inactiveFiveStarIcon: require('assets/img/home/inactive_fiveStarIcon@2x.png'),
    fiveStarIcon: require('assets/img/home/fiveStarIcon@2x.png')
  },
  voucher: {
    homeIcon: require('assets/img/voucher/homeIcon@2x.png'),
    inactiveHomeIcon: require('assets/img/voucher/inactiveHomeIcon@2x.png'),
    carIcon: require('assets/img/voucher/carIcon@2x.png'),
    inactiveCarIcon: require('assets/img/voucher/inactiveCarIcon@2x.png'),
    noStarFilterIcon: require('assets/img/voucher/noStarVoucherFilterIcon@2x.png'),
    fiveStarFilterIcon: require('assets/img/voucher/fiveStarVoucherFilterIcon@2x.png'),
    myVoucherFilterIcon: require('assets/img/voucher/myVoucherFilterIcon@2x.png'),
    homeServiceFilterIcon: require('assets/img/voucher/homeServiceFilterIcon@2x.png'),
    iconHome: require('assets/img/voucher/iconHome@2x.png'),
    iconMap: require('assets/img/voucher/iconMap@2x.png'),
    iconSale: require('assets/img/voucher/iconSale@2x.png'),
    iconVip: require('assets/img/voucher/iconVip@2x.png'),
    iconGym: require('assets/img/voucher/iconGym@2x.png'),
    iconKing: require('assets/img/voucher/iconKing@2x.png'),
    iconTrending: require('assets/img/voucher/iconTrending@2x.png'),
    bgTree: require('assets/img/voucher/bgTree@2x.png')
  },
  service: {
    address: require('assets/img/service/address@3x.png'),
    duration: require('assets/img/service/duration@3x.png'),
    money: require('assets/img/service/money@3x.png'),
    store: require('assets/img/service/store@3x.png')
  },
  shop: {
    iconHeart: require('assets/img/shop/iconHeart@2x.png'),
    iconComment: require('assets/img/shop/iconComment@2x.png')
  },
  catPersonal: require('assets/img/cat@2x.png')
};

exports.default = Images;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Images.js
// module id = 42
// module chunks = 0